import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
function _createSuper(t) { var r = _isNativeReflectConstruct(); return function () { var e, o = _getPrototypeOf(t); if (r) { var s = _getPrototypeOf(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return _possibleConstructorReturn(this, e); }; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import { BaseMediaClientError } from '../../models/errors';
export var MediaStoreError = /*#__PURE__*/function (_BaseMediaClientError) {
  _inherits(MediaStoreError, _BaseMediaClientError);
  var _super = _createSuper(MediaStoreError);
  function MediaStoreError(reason, innerError) {
    var _this;
    _classCallCheck(this, MediaStoreError);
    _this = _super.call(this, reason);
    _this.reason = reason;
    _this.innerError = innerError;
    return _this;
  }
  _createClass(MediaStoreError, [{
    key: "attributes",
    get: function get() {
      var reason = this.reason,
        innerError = this.innerError;
      return {
        reason: reason,
        innerError: innerError
      };
    }
  }]);
  return MediaStoreError;
}(BaseMediaClientError);
export function isMediaStoreError(err) {
  return err instanceof MediaStoreError;
}